import { createAuthProvider } from "@react-keycloak/core";
import { reactKeycloakContext } from "./ReactKeycloakContext";
export var ReactKeycloakProvider = createAuthProvider(reactKeycloakContext);
//# sourceMappingURL=ReactKeycloakProvider.js.map